import { checkPermissionByKey } from "../utils/checkPermissionByKey";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
import UserSolutionCoachForm from "../../src/components/UserSolutionCoachForm"

const SolutionCoachesDetailView = () => {
  const userData = useSelector((state) => state?.user);
  const [isEditing, setIsEditing] = useState(false);
  const location = useLocation();
  const { user } = location.state || {};
  const [updatedUser, setUpdatedUser] = useState(user);
  const { id } = useParams();
  const businessIdentifier = userData.user?.businessIdentifier;
  const navigate = useNavigate();

  if (!user) {
    return <div>No user data available</div>;
  }

  const handleEditToggle = () => {
    setIsEditing(true);
  };

  return (
    <>
      {!isEditing ? (
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={styles.container}>
            <div style={styles.header}>
              <h2 style={styles.title}>{user.name}</h2>
              <div style={styles.buttonContainer}>
                <button
                  onClick={handleEditToggle}
                  style={styles.editButton}
                >
                  Edit
                </button>
              </div>
            </div>
            <div style={styles.infoContainer}>
              <div className="text-center" style={styles.infoRow}>
                <img
                className="mx-auto"
                  src={user.profile_image_url}
                  alt={user.name}
                  style={{ width: "200px", height: "200px", borderRadius: "50%" }}
                  onError={(e) => {
                    e.target.src = "/placeholder-image.png";
                  }}
                />           
              </div>
            </div>
            <ToastContainer />
          </div>
          {!businessIdentifier && (
            <div style={styles.container}>
              <div style={styles.header}>
                <h2 style={styles.title}>{user.name} Intro Video</h2>
              </div>
              <div className="text-center" style={styles.infoRow}>

                  {user.intro_video_url && (
                    <video
                    className="mx-auto"
                      width="600"
                      height="200"
                      controls
                      style={{ borderRadius: "8px" }}
                      onError={(e) => {
                        console.error("Video failed to load", e);
                      }}
                    >
                      <source src={user.intro_video_url} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
              </div>
            </div>
          )}
        </div>
      ) : (
        <UserSolutionCoachForm user={updatedUser} />
      )}
    </>
  );
};

const styles = {
  container: {
    backgroundColor: "#fff",
    border: "0px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    fontFamily: "Poppins",
    overflow: "hidden",
    width: "600px",
  },
  header: {
    alignItems: "center",
    backgroundColor: "#064260",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 35px",
  },
  title: {
    fontSize: "21px",
    fontWeight: 600,
    margin: 0,
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
  },
  deactivateButton: {
    backgroundColor: "#FF0000",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  activateButton: {
    backgroundColor: "#3ABF19",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  editButton: {
    backgroundColor: "#27B99A",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  infoContainer: {
    border: "0",
    padding: "0",
  },
  infoRow: {
    borderBottom: "1px solid #eee",
    display: "flex",
    fontSize: "1em",
    justifyContent: "space-between",
    padding: "20px 35px",
  },
  span: {
    fontSize: "17px",
    fontWeight: 600,
    margin: 0,
  },
  modalOverlay: {
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
  },
  modalContainer: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "396px",
    padding: "35px 46px 55px 46px",
    textAlign: "center",
  },
  modalText: {
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "1.5",
    wordWrap: "break-word",
  },
  confirmButton: {
    border: "none",
    color: "#B760E5",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    padding: "10px 15px",
  },
  cancelButton: {
    border: "none",
    color: "#B760E5",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    padding: "10px 15px",
  },
  td: {
    borderBottom: "1px solid #ddd",
    padding: "19px 10px",
    textAlign: "left",
  },
};

export default SolutionCoachesDetailView;
